import { gql } from '@apollo/client';
import { GOVERNANCE_POLICY_FRAGMENT } from '../../../fragments/governance-policy';

// query to fetch a single policy by its ID
export const GET_POLICY_BY_POLICY_ID = gql`
  query GET_POLICY_BY_POLICY_ID($policyId: String!) {
    cgp_governance_entity(where: { governance_entity_id: { _eq: $policyId } }) {
      ${GOVERNANCE_POLICY_FRAGMENT}
    }
  }
`;

// batch query to fetch multiple policies by their IDs
export const GET_POLICIES_BY_IDS = gql`
  query GET_POLICIES_BY_IDS($policyIds: [String!]!) {
    cgp_governance_entity(where: { governance_entity_id: { _in: $policyIds } }) {
      ${GOVERNANCE_POLICY_FRAGMENT}
    }
  }
`;
